.root {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}
.track {
  display: grid;
  width: calc(var(--space-8) * 5);
  max-width: 100%;
  height: var(--space-3);
  overflow: hidden;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: var(--space-1);
  border-radius: var(--radius-pill);
}
.track > span {
  background: var(--color-surface-tinted);
}
.track > span[data-filled] {
  background: var(--gradient-accent);
}
